import { createTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';

// Centralized MUI theme based on the provided style guide
const primaryBlue = '#1976D2'; // Material Blue 700
const primaryBlueLight = '#E3F2FD';
const neutralBg = '#F9FAFB';
const neutralBorder = '#E0E0E0';
const textPrimary = '#212121';
const textSecondary = '#616161';

const theme = createTheme({
  shape: { borderRadius: 12 },
  palette: {
    mode: 'light',
    primary: { main: primaryBlue },
    background: {
      default: neutralBg,
      paper: '#FFFFFF',
    },
    divider: neutralBorder,
    text: {
      primary: textPrimary,
      secondary: textSecondary,
    },
    success: { main: '#2E7D32' },
    warning: { main: '#ED6C02' },
    info: { main: '#0288D1' },
    error: { main: '#D32F2F' },
  },
  typography: {
    // Inter is the primary font per style guide (fallbacks remain)
    fontFamily: 'Inter, Roboto, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica, Arial, sans-serif',
    h1: { fontWeight: 700, fontSize: '2rem' },
    h2: { fontWeight: 700, fontSize: '1.75rem' },
    h3: { fontWeight: 700, fontSize: '1.5rem' },
    h4: { fontWeight: 700, fontSize: '1.375rem' },
    h5: { fontWeight: 600, fontSize: '1.25rem' },
    h6: { fontWeight: 600, fontSize: '1.125rem' },
    body2: { fontWeight: 400, color: textSecondary },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 10,
        },
        containedPrimary: {
          color: '#fff',
        },
        outlinedPrimary: {
          backgroundColor: '#FFFFFF',
          borderColor: primaryBlue,
          color: primaryBlue,
          '&:hover': {
            backgroundColor: primaryBlueLight,
            borderColor: primaryBlue,
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: neutralBg,
          borderRight: `1px solid ${neutralBorder}`,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 8,
          position: 'relative',
          '&.Mui-selected': {
            backgroundColor: primaryBlueLight,
            borderLeft: `4px solid ${theme.palette.primary.main}`,
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
              color: theme.palette.primary.main,
              fontWeight: 600,
            },
          },
          '&.Mui-selected:hover': {
            backgroundColor: alpha(primaryBlue, 0.25),
          },
          '&:hover': {
            backgroundColor: alpha(primaryBlue, 0.06),
          },
        }),
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0px 1px 3px rgba(0,0,0,0.1)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          '&:hover': {
            boxShadow: '0px 4px 12px rgba(0,0,0,0.12)',
            transform: 'scale(1.01)'
          },
        },
      },
    },
    MuiAppBar: {
      defaultProps: { color: 'default' },
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: textPrimary,
          borderBottom: `1px solid ${neutralBorder}`,
          boxShadow: 'none',
        },
      },
    },
  },
});

export default theme;

